// extracted by mini-css-extract-plugin
export default {"avatarContainer":"avatarProfile_avatarContainer__Loqb0"};